module.exports = "pegasus/assets/header-fall-default-1.jpg";